import { combineReducers } from "redux";

import { alert } from "./alert.reducer";

import { authentication } from "./authentication.reducer";
import { registration } from "./registration.reducer";
import { users } from "./users.reducer";
import { vehicles } from "./vehicles.reducer";
import { auctions } from "./auctions.reducer";
import { utility } from "./utility.reducer";
import { batch } from "./batch.reducer";
import { paperwork } from "./paperwork.reducer";

const rootReducer = combineReducers({
  authentication,
  registration,
  users,
  vehicles,
  auctions,
  utility,
  batch,
  paperwork,
  alert
});

export default rootReducer;
